<div class="claim_body">
    <div class="top_panel">
      <h3>Add a Complaint</h3>
      <span (click)="close()" class="close">
          <img src="https://cdn.elitehw.com/images/cross.webp" />
      </span>
    </div>
    <div class="formarea">
      <form [formGroup]="complaintForm">
        <div class="inputprt">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Platform</mat-label>
            <mat-select formControlName="platform">
                <mat-option value="BBB">BBB</mat-option>
                <mat-option value="Google">Google</mat-option>
                <mat-option value="Yelp">Yelp</mat-option>
                <mat-option value="TrustPilot">TrustPilot</mat-option>
                <mat-option value="ConsumerAffairs">ConsumerAffairs</mat-option>
                <mat-option value="HomeWarrantyReviews">HomeWarrantyReviews</mat-option>
                <mat-option value="BestCompany">BestCompany</mat-option>
              </mat-select>
            <mat-error
            *ngIf="complaintForm.controls['platform'].touched && complaintForm.controls['platform'].hasError('required')">
            This is required field.
        </mat-error>
        
          </mat-form-field>

          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Priority</mat-label>
            <mat-select formControlName="priority">
                <mat-option value="Low">Low</mat-option>
                <mat-option value="Medium">Medium</mat-option>
                <mat-option value="High">High</mat-option>
                <mat-option value="Critical">Critical</mat-option>
              </mat-select>
            <mat-error
            *ngIf="complaintForm.controls['priority'].touched && complaintForm.controls['priority'].hasError('required')">
            This is required field.
        </mat-error>
        
          </mat-form-field>

          <mat-form-field fxFlex="auto" appearance="outline">
          <mat-label>Agent</mat-label>
                    <mat-select matNativeControl formControlName="assigned">
                        <mat-option *ngFor="let item of agents"
                            value="{{item?.userId}}">{{commonService.getFullName(item?.firstName,
                            item?.lastName)}}</mat-option>
                    </mat-select>
          </mat-form-field>

          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Feedback Rating</mat-label>
            <mat-select formControlName="rating" >
              <mat-option value="Awful">Awful</mat-option>
              <mat-option value="Poor">Poor</mat-option>
              <mat-option value="Fair">Fair</mat-option>
            </mat-select>

          </mat-form-field>

          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Complaint</mat-label>
            <textarea matInput formControlName="complaint"></textarea>
            <mat-error
            *ngIf="complaintForm.controls['complaint'].touched && complaintForm.controls['complaint'].hasError('required')">
            This is required field.
        </mat-error>
        </mat-form-field>

        </div>
        <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          <button mat-button type="button" class="sub-button" (click)="handleSaveComplaint()"><span>Add</span></button>
          <button mat-button type="button" class="can-button" (click)="close()"><span>Cancel</span></button>
        </div>
      </form>
    </div>
  </div>
  